import { ACTION_TYPE, SupporterAction } from '../actions/supporter'
import { Supporter } from '../public/models/supporter'
import { Status } from '@owl-nest/redux-wrapper'

export type State = {
  supporters: Supporter[]
  next: string | null
  status: {
    load: Status
  }
}

export const initialState: State = {
  supporters: [],
  next: null,
  status: {
    load: Status.PRISTINE,
  },
}

export function reducer(state = initialState, action: SupporterAction): State {
  switch (action.type) {
    case ACTION_TYPE.LOAD_SUPPORTERS_REQUEST: {
      return {
        ...state,
        status: {
          ...state.status,
          load: Status.PENDING,
        },
      }
    }
    case ACTION_TYPE.LOAD_SUPPORTERS_FAILURE: {
      return {
        ...state,
        supporters: [],
        next: null,
        status: {
          ...state.status,
          load: Status.FAILURE,
        },
      }
    }
    case ACTION_TYPE.LOAD_SUPPORTERS_SUCCESS: {
      if (action.success.forceClean) {
        return {
          ...state,
          supporters: action.success.supporters,
          next: action.success.meta.next,
          status: {
            ...state.status,
            load: Status.SUCCESS,
          },
        }
      }
      return {
        ...state,
        supporters: state.supporters.concat(action.success.supporters),
        next: action.success.meta.next,
        status: {
          ...state.status,
          load: Status.SUCCESS,
        },
      }
    }
    default:
      return state
  }
}
